module.exports = __webpack_public_path__ + "img/iframe.1f454960.svg";